(() => {
  const configuration = document.getElementById('signal-search-config');
  if (!configuration) return;
  const config = JSON.parse(configuration.textContent);
  const aliases = {
    adaptadores: /\badaptador(?:es)?\b|\bcoples?\b/,
    'cables-1': /\bcables?(?:\s+coaxiales?)?\b/,
    conectores: /\bconector(?:es)?\b/,
    divisores: /\bdivisor(?:es)?\b|\bsplitters?\b/
  };
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/\brp[\s-]*sma\b/g, 'rp-sma').replace(/\btipo\s+n\b/g, 'n')
    .replace(/\bmachos\b/g, 'macho').replace(/\bhembras\b/g, 'hembra').replace(/\s+/g, ' ').trim();
  const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const knownInterfaces = ['RP-SMA', 'SMA', 'TNC', 'BNC', 'N', 'F', 'UHF'];
  const prefixes = /\b(?:busco|buscar|necesito|quiero|un|una|unos|unas|de|del|a|con|para|rf|coaxial|coaxiales)\b/g;
  const generalHandles = {n: 'tipo-n'};
  const escapeHtml = value => value.replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const emptyResults = (message = config.noResults) => `<p class="text--large">${escapeHtml(message)}</p><div class="button-wrapper"><button type="button" data-action="reset-search" class="button button--primary">${escapeHtml(config.newSearch)}</button></div>`;

  function resolve(term) {
    let remaining = normalize(term);
    if (!remaining || /[:"()]/.test(remaining)) return null;
    const matches = config.families.filter(family => aliases[family.key]?.test(remaining));
    if (matches.length !== 1) return null;
    const family = matches[0];
    const types = (family.types || []).filter(type => aliases[family.key].test(normalize(type)));
    if (!family.url || !types.length) return null;
    remaining = remaining.replace(aliases[family.key], ' ');
    const vocabulary = new Map(family.tags.map(tag => [normalize(tag.value), tag]));
    const interfaces = new Set(knownInterfaces.map(normalize));
    for (const tag of family.tags) {
      const match = normalize(tag.value).match(/^(.+) (macho|hembra)$/);
      if (match) interfaces.add(match[1]);
    }
    const interfacePattern = [...interfaces].sort((a, b) => b.length - a.length).map(escapePattern).join('|');
    const ports = [];
    remaining = remaining.replace(new RegExp(`(?<![\\w-])(${interfacePattern})(?:\\s+(macho|hembra))?(?![\\w-])`, 'g'), (_, connection, gender) => {
      ports.push({connection, gender, tag: vocabulary.get(`${connection}${gender ? ` ${gender}` : ''}`)});
      return ' ';
    });
    remaining = remaining.replace(prefixes, ' ').replace(/[.,;\s]+/g, ' ').trim();
    const repeatedPort = ports.length > new Set(ports.map(port => `${port.connection} ${port.gender || ''}`)).size;
    const completePortFamily = ['adaptadores', 'cables-1'].includes(family.key);
    const exact = !remaining && !repeatedPort && ports.length <= 2 && ports.every(port => port.tag || completePortFamily);
    const url = new URL(exact ? family.url : config.searchUrl, location.origin);
    if (exact && ports.length) {
      const handles = [...new Set(ports.map(port => port.tag?.handle || (port.gender ? `${port.connection}-${port.gender}` : generalHandles[port.connection] || port.connection)))];
      url.pathname += '/' + handles.join('+');
    }
    if (!exact) {
      url.searchParams.set('q', term.trim());
      url.searchParams.set('type', 'product');
      for (const type of types) url.searchParams.append('filter.p.product_type', type);
    }
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return {url, exact, family: family.key};
  }

  function normalizedPath(url) {
    const path = decodeURIComponent(new URL(url, location.origin).pathname);
    return path.split('/').map(part => part.split('+').sort().join('+')).join('/').replace(/\/$/, '');
  }

  async function retrieve(result, signal) {
    const url = new URL(result.url.href);
    url.searchParams.set('section_id', 'predictive-search-compatibility');
    const response = await fetch(url.href, {signal});
    if (!response.ok) throw new Error('Search request failed');
    if (result.exact && normalizedPath(response.url) !== normalizedPath(result.url.href)) {
      return {safeRoute:false, hasResults:false, html:emptyResults()};
    }
    const container = document.createElement('div');
    container.innerHTML = await response.text();
    const section = container.querySelector('.shopify-section--predictive-search');
    if (!section) throw new Error('Search section unavailable');
    return {safeRoute:true, hasResults:section.querySelector('.predictive-search__results-categories') !== null, html:section.innerHTML};
  }

  let submission = 0;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== 'predictive-search-form' && !form.classList.contains('main-search__form')) return;
    const input = form.querySelector('[name="q"]');
    if (!input || new URL(form.action, location.origin).pathname !== config.searchUrl) return;
    const result = resolve(input.value);
    if (!result) return;
    event.preventDefault();
    const currentSubmission = ++submission;
    const submittedTerm = input.value;
    if (result.exact) {
      const results = await retrieve(result).catch(() => ({safeRoute:false,html:emptyResults(config.requestError)}));
      if (currentSubmission !== submission || input.value !== submittedTerm) return;
      if (!results.safeRoute) {
        const drawer = document.getElementById('search-drawer');
        drawer.open = true;
        drawer.inputElement.value = submittedTerm;
        drawer.loadingStateElement.hidden = true;
        drawer.resultsElement.hidden = false;
        drawer.resultsElement.innerHTML = results.html;
        drawer.drawerFooterElement.hidden = true;
        drawer.drawerContentElement.classList.add('drawer__content--center');
        if (drawer.menuListElement) drawer.menuListElement.hidden = true;
        return;
      }
    }
    location.assign(result.url.href);
  }, true);

  customElements.whenDefined('predictive-search-drawer').then(() => {
    const prototype = customElements.get('predictive-search-drawer').prototype;
    const originalPredictive = prototype._doPredictiveSearch;
    const originalLiquid = prototype._doLiquidSearch;
    const search = async function(term, original) {
      const result = resolve(term);
      if (!result) return original.call(this, term);
      return retrieve(result, this.abortController.signal).catch(error => {
        if (error.name === 'AbortError') throw error;
        return {hasResults:false,html:emptyResults(config.requestError)};
      });
    };
    prototype._doPredictiveSearch = function(term) { return search.call(this, term, originalPredictive); };
    prototype._doLiquidSearch = function(term) { return search.call(this, term, originalLiquid); };
  });
})();
